import tag from '@123/druid/dist/Framework/Decorators/Tag';
import Numbers from '@123/druid/dist/Utility/Numbers';
import * as defaults from '@Component/Input/StepperDefaultValues';
import StepperUI from '@Component/Input/StepperUI';

@tag('dr-stepper')
export default class Stepper extends HTMLElement {
    private ui: StepperUI;

    constructor() {
        super();

        this.ui = new StepperUI(this);
    }

    get min(): number {
        return this.attributeMap().getInt('min', defaults.min);
    }

    set min(value: number) {
        this.attributeMap().setInt('min', value);
    }

    get max(): number {
        return this.attributeMap().getInt('max', defaults.max);
    }

    set max(value: number) {
        this.attributeMap().setInt('max', value);
    }

    get step(): number {
        return this.attributeMap().getInt('step', defaults.step);
    }

    set step(value: number) {
        this.attributeMap().setInt('step', value);
    }

    get value(): number {
        return parseInt(this.ui.valueElement.value);
    }

    set value(value: number) {
        if (this.disabled) {
            return;
        }

        value = Numbers.range(isNaN(value) ? 0 : value, this.min, this.max);
        this.ui.valueElement.value = value.toString();
        this.attributeMap().setInt('value', value);

        if (value <= this.min) {
            this.ui.decrementButton.classList.add('c-stepper__decrement--disabled');
        } else {
            this.ui.decrementButton.classList.remove('c-stepper__decrement--disabled');
        }
        if (value >= this.max) {
            this.ui.incrementButton.classList.add('c-stepper__increment--disabled');
        } else {
            this.ui.incrementButton.classList.remove('c-stepper__increment--disabled');
        }
    }

    get disabled(): boolean {
        return this.attributeMap().has('disabled');
    }

    public connectedCallback(): void {
        this.ui.incrementButton.addEventListener('click.stepper', () => {
            if (this.ui.incrementButton.attributeMap().has('disabled') === false) {
                this.value += this.step;
            }
        });
        this.ui.decrementButton.addEventListener('click.stepper', () => {
            if (this.ui.incrementButton.attributeMap().has('disabled') === false) {
                this.value -= this.step;
            }
        });
        this.ui.valueElement.addEventListener('input.stepper', (evt) => {
            const value = (<HTMLInputElement>evt.target).value.replace(/[^0-9]/g, '');
            this.value = parseInt(value);
        });
    }

    public disconnectedCallback(): void {
        this.ui.incrementButton.removeEventListeners('click.stepper');
        this.ui.decrementButton.removeEventListeners('click.stepper');
        this.ui.valueElement.removeEventListeners('input.stepper');
    }

    protected attributeChangedCallback(name: string, _oldValue: string, newValue: string | null): void {
        switch (name) {
            case 'value':
                if (_oldValue === newValue) {
                    return;
                }
                this.value = Number(newValue);
                break;
            case 'disabled':
                this.ui.incrementButton.disabled = newValue !== null;
                this.ui.decrementButton.disabled = newValue !== null;
                this.ui.valueElement.disabled = newValue !== null;
                if (newValue !== null) {
                    this.classList.add('c-stepper--disabled');
                } else {
                    this.classList.remove('c-stepper--disabled');
                }
        }
    }

    static get observedAttributes(): string[] {
        return ['value', 'min', 'max', 'step', 'disabled'];
    }
}
